<template>
    <div class="message-content">
        <el-tabs :tab-position="tabPosition" @tab-click="handleTabClick" v-model="tabName" >
          <!-- 全部类型消息 -->
          <el-tab-pane class="content-total" name="first" label="全部类型消息">
              <div class="content-total-item" style="padding-top: 12px;">
                 <MessageTable
                    ref="dynamicTable1"
                    :pageData="pageData"
                    :page="page"
                    :isShowUpdAllBtn="isShowUpdAllBtn"
                    @queryTableData="queryTableData"
                    @handleMessageDelete="handleMessageDelete"
                    @linkPage="linkPage"
                    @handleAllMessageDelete="handleAllMessageDelete"
                    @handleAllMessageRead="handleAllMessageRead"
                  />
                 
              </div>
          </el-tab-pane>
          <!-- 公告消息 -->
          <el-tab-pane v-if="this.isPay > '0'" name="seventh" label="公告消息">
                <div class="content-total-item"  style="padding-top: 12px;">
                    <MessageTable
                        ref="dynamicTable7"
                        :pageData="pageData"
                        :page="page"
                        :msgType = 6
                        :isShowUpdAllBtn="isShowUpdAllBtn"
                        @queryTableData="queryTableData"
                        @handleMessageDelete="handleMessageDelete"
                        @linkPage="linkPage"
                        @handleAllMessageDelete="handleAllMessageDelete"
                        @handleAllMessageRead="handleAllMessageRead"
                    />
                </div>
          </el-tab-pane>
          <!-- 流程消息 -->
          <el-tab-pane v-if="this.isPay > 0" name="second" label="流程消息">
          <div class="content-total-item"  style="padding-top: 12px;">
              <MessageTable
                ref="dynamicTable2"
                :pageData="pageData"
                :page="page"
                :msgType = 1
                :isShowUpdAllBtn="isShowUpdAllBtn"
                @queryTableData="queryTableData"
                @handleMessageDelete="handleMessageDelete"
                @linkPage="linkPage"
                @handleAllMessageDelete="handleAllMessageDelete"
                @handleAllMessageRead="handleAllMessageRead"
              />
              </div>
          </el-tab-pane>
          <!-- 任务消息 -->
          <el-tab-pane v-if="this.isPay > 0" name="third" label="任务消息">
          <div class="content-total-item"  style="padding-top: 12px;">
              <MessageTable
                ref="dynamicTable3"
                :pageData="pageData"
                :page="page"
                :msgType = 2
                :isShowUpdAllBtn="isShowUpdAllBtn"
                @queryTableData="queryTableData"
                @handleMessageDelete="handleMessageDelete"
                @linkPage="linkPage"
                @handleAllMessageDelete="handleAllMessageDelete"
                @handleAllMessageRead="handleAllMessageRead"
              />
              </div>
          </el-tab-pane>
          <!-- 表单消息 -->
          <el-tab-pane name="four" label="表单消息">
              <div class="content-total-item"  style="padding-top: 12px;">
               <MessageTable
                ref="dynamicTable4"
                :pageData="pageData"
                :page="page"
                :msgType = 3
                :isShowUpdAllBtn="isShowUpdAllBtn"
                @queryTableData="queryTableData"
                @handleMessageDelete="handleMessageDelete"
                @linkPage="linkPage"
                @handleAllMessageDelete="handleAllMessageDelete"
                @handleAllMessageRead="handleAllMessageRead"
              />
              </div>
          </el-tab-pane>
          <!-- 档案消息 -->
          <el-tab-pane v-if="this.isPay > '0'" name="fifth" label="档案消息">
              <div class="content-total-item"  style="padding-top: 12px;">
                  <MessageTable
                    ref="dynamicTable5"
                    :pageData="pageData"
                    :page="page"
                    :msgType = 4
                    :isShowUpdAllBtn="isShowUpdAllBtn"
                    @queryTableData="queryTableData"
                    @handleMessageDelete="handleMessageDelete"
                    @linkPage="linkPage"
                    @handleAllMessageDelete="handleAllMessageDelete"
                    @handleAllMessageRead="handleAllMessageRead"
                  />
              </div>
          </el-tab-pane>
          <!-- 产品消息 -->
          <el-tab-pane v-if="this.isPay > '0'" name="sixth" label="产品消息">
            <div class="content-total-item"  style="padding-top: 12px;">
             <MessageTable
                ref="dynamicTable6"
                :pageData="pageData"
                :page="page"
                :msgType = 5
                :isShowUpdAllBtn="isShowUpdAllBtn"
                @queryTableData="queryTableData"
                @handleMessageDelete="handleMessageDelete"
                @linkPage="linkPage"
                @handleAllMessageDelete="handleAllMessageDelete"
                @handleAllMessageRead="handleAllMessageRead"
              />
              </div>
          </el-tab-pane>
          <!-- 催办消息 -->
          <el-tab-pane v-if="this.isPay > '0'" name="eighth" label="催办消息">
                <div class="content-total-item"  style="padding-top: 12px;">
                    <MessageTable 
                        ref="dynamicTable7"
                        :pageData="pageData"
                        :page="page"
                        :msgType = 7
                        :isShowUpdAllBtn="isShowUpdAllBtn"
                        @queryTableData="queryTableData"
                        @handleMessageDelete="handleMessageDelete"
                        @linkPage="linkPage"
                        @handleAllMessageDelete="handleAllMessageDelete"
                        @handleAllMessageRead="handleAllMessageRead"
                    />
                </div>
          </el-tab-pane>

      </el-tabs>
      <el-dialog
            title="消息简要"
            append-to-body
            :visible.sync="isShowDetail">
            <el-form  :model="messageInfo" size="mini" label-width="120px" class="message-form">
                <el-form-item label="消息类型:" prop="msgTitle">
                    <el-tag>普通消息</el-tag>
                </el-form-item>
                <el-form-item label="消息标题:" prop="msgTitle">
                    <!-- <div class="message-item-pre message-item-content">
                        {{messageInfo.msgTitle}}
                    </div> -->
                     <el-input readonly  v-model="messageInfo.msgTitle"></el-input>
                </el-form-item>
                <el-form-item label="消息内容:" prop="msgContent">
                    <!-- <div style="white-space: pre-line;" class="message-item-pre message-item-content">
                        {{messageInfo.msgContent}}
                    </div> -->
                    <el-input readonly type="textarea" style="width:99%" :rows="6"  v-model="messageInfo.msgContent"></el-input>
                </el-form-item>
                <el-form-item v-if="messageInfo.linkedUrl" label="访问详情" prop="linkedUrl">
                    <div style="cursor:pointer;" @click.stop="linkToDetailPage()">
                        <span class="message-item-pre tag-link span-line">点击进入</span>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            title="查看公告"
            top="4vh"
            width="95%"
            :fullscreen=true
            :visible.sync="isShowNoticeDetail"
            append-to-body
          >
            <NoticeDetail ref="detailRef" :key="loadTimer" :notice="noticeDetail" @closeDialog="closeDialog"/>
        </el-dialog>
    </div>
</template>

<script>
import { getProcessTaskDetail, getMessageList, updMessage, deleteMessage, updAllMessageStatus, delAllMessage } from '@/data-model';
import mixinsNav from '@/mixins/mixins-nav';
import MessageTable from '@/components/Message/MessageTable';
import NoticeDetail from '@/pages/application/Notice/NoticeDetail';
import Notice from '@/pages/application/Notice/Notice';
import { isEmpty } from 'lodash';
export default {
    mixins: [ mixinsNav ],
    // register the component
    components: {
        MessageTable,
        NoticeDetail,
        Notice
    },
    data () {
        return {
            tabName: 'first',
            tabPosition: 'top',
            tableHeight: '460px',
            isShowDetail: false,
            isShowNoticeDetail: false,
            noticeDetail: {},
            loadTimer: '',
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            tableLoading: false,
            pageData: [],
            tableColumns: [
                {
                    id: '1',
                    prop: 'msgTitle',
                    label: '消息标题'
                },
                {
                    id: '2',
                    prop: 'sendTime',
                    label: '产生时间'
                },
                {
                    id: '3',
                    prop: 'msgTypeView',
                    label: '消息类型'
                }
            ],
            searchParams: {
                msgType: null, // 消息类型 null全部 0:系统 1流程 2任务 3表单 4档案  5产品 ...
                msgStatus: null // 消息阅读状态 null全部 0未读 1已读
            },
            messageInfo: {
                msgTitle: '',
                msgContent: '',
                linkedUrl: ''
            },
            messageParam: {
                msgflag: 0,
                msgStatus: '',
                msgType: ''
            },
            isPay: -1, // 企业是否为付款企业，0:未付款，1：已付款
            resourceVersion: 0 // 1:免费版，2：体验版，4：企业版
        };
    },
    props: {
        // msgType: { // 消息类型
        //     type: Number
        // },
        msgStatus: { // 消息阅读状态
            type: Number
        },
        isShowUpdAllBtn: {
            type: Boolean,
            default: false
        }
    },
    created () {
        let isShowNotice = sessionStorage.getItem('isShowNotice');
        if (!isEmpty(isShowNotice)) { // 是否显示草稿页签
            this.searchParams.msgType = 6;
            this.tabName = 'seventh';
            sessionStorage.removeItem('isShowNotice');
        }
        let currentUserStr = sessionStorage.getItem('currentUserInfo');
        if (currentUserStr) {
            let currentUserInfo = JSON.parse(currentUserStr);
            this.isPay = currentUserInfo.companyInfo.isPay;
            this.resourceVersion = currentUserInfo.companyInfo.companyResource.resourceVersion;
        }
        this.initData();
    },
    methods: {
        initData () {
            this.queryTableData(this.page);
        },
        handleTabClick (tab, event) {
            this.pageData = [];
            this.page = {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            };
            // null全部 0:系统 1流程 2任务 3表单 4档案  5产品 6公告
            if (tab.name === 'first') {
                this.searchParams.msgType = null;
            } else if (tab.name === 'seventh') {
                this.searchParams.msgType = 6;
            } else if (tab.name === 'second') {
                this.searchParams.msgType = 1;
            } else if (tab.name === 'third') {
                this.searchParams.msgType = 2;
            } else if (tab.name === 'four') {
                this.searchParams.msgType = 3;
            } else if (tab.name === 'fifth') {
                this.searchParams.msgType = 4;
            } else if (tab.name === 'sixth') {
                this.searchParams.msgType = 5;
            } else if (tab.name === 'eighth') {
                this.searchParams.msgType = 7;
            }
            this.queryTableData(this.page);
        },
        queryTableData ({currentPage}) {
            this.page.currentPage = currentPage;
            this.renderTableList();
        },
        async renderTableList () {
            this.tableLoading = true;
            this.searchParams.msgStatus = this.msgStatus;
            let formData = await getMessageList(Object.assign({}, {
                currentPage: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.searchParams));
            if (formData.data) {
                this.pageData = formData.data;
            } else {
                this.pageData = [];
            }
            // console.log(this.isSubform);
            this.page = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.tableLoading = false;
        },
        async handleMessageDelete (row) {
            this.$confirm(`您确定要删除当前消息吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                await deleteMessage(row.id);
                await this.queryTableData(this.page);
            }).catch(() => {});
        },
        linkPage (row) {
            updMessage(row);
            // this.navigateTo(row.linkedUrl);
            // this.navMessage(row.id);
            this.messageInfo = row;
            if (this.messageInfo.msgType === 6) {
                this.noticeDetail = {id: row.linkedUrl};
                this.loadTimer = new Date().getTime();
                this.isShowNoticeDetail = true;
            } else {
                this.isShowDetail = true;
                setTimeout(() => { // 更新navbar上消息红点
                    this.$parent.$parent.$children[0].setMessageHot();
                }, 0);
            }
        },
        async linkToDetailPage () {
            this.isShowDetail = false;
            if (this.messageInfo.msgTemplateCode === '0710010001') {
                let taskInstanceId = this.messageInfo.linkedUrl;
                // console.log(taskInstanceId);
                let taskInfo = await getProcessTaskDetail(taskInstanceId);
                let processTaskStr = {};
                processTaskStr.processInstanceId = taskInfo.processInstanceId;
                processTaskStr.processInstanceName = taskInfo.processInstanceName;
                processTaskStr.taskInstanceId = taskInstanceId;
                processTaskStr.taskName = taskInfo.name;
                processTaskStr.taskState = taskInfo.taskState;
                let processTaskJson = JSON.stringify(processTaskStr);
                sessionStorage.setItem('navToTaskList', processTaskJson);
                this.navMyTaskMyAssignee();// 我负责
            } else if (this.messageInfo.msgTemplateCode === '0710010002') {
                // let approvalInstanceId = this.messageInfo.linkedUrl;
                // console.log(approvalInstanceId);
                this.navMyApprovalApprove();// 我审批
            } else {
                this.navigateTo(this.messageInfo.linkedUrl);
            }
        },
        async handleAllMessageDelete (msgType) {
            this.$confirm(`您确定要删除所有消息吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                // console.log(msgType);
                this.messageParam.msgType = msgType;
                this.messageParam.msgStatus = this.msgStatus;
                await delAllMessage(this.messageParam);
                await this.queryTableData(this.page);
            }).catch(() => {});
        },
        async handleAllMessageRead (msgType) {
            this.$confirm(`您确定要所有未读消息标为已读吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                this.messageParam.msgType = msgType;
                await updAllMessageStatus(this.messageParam);
                await this.queryTableData(this.page);

                setTimeout(() => { // 更新navbar上消息红点
                    this.$parent.$parent.$children[0].setMessageHot();
                }, 0);
            }).catch(() => {});
        },
        closeDialog () {
            this.isShowNoticeDetail = false;
        }
    }
};
</script>

<style lang="less" scoped="scoped">
  .message-content{
      width: 100%;
      .content-total{
         .content-total-item{
              padding-top: 14px;
              height: 80vh;
              @media screen and (min-width: 1024px) and (max-width: 1366px) {
                 height: 70vh;
              }
          }
      }
  }
  .message-item-pre{
      padding-left: 10px;
      margin-left:14px;
  }
  .message-item-content{
      width: 360px;
      border: 1px solid #ebebeb;
      border-radius: 3px;
      transition: .2s;
      background: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
  }
  .span-line{
      color:rgb(19, 206, 102);
  }
  .span-line:hover{
      text-decoration:underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/MessageNotice/MessageNotice.vue